// The ready-list physician home switch (ON by default since 15 Oct, see encounter-flags.ts; `?x=-ready-list` turns it off in
// this browser, `?x=ready-list` or `?ef=readyList` on again). Where home is follows it: home-path.ts. Read once per mount,
// the same pattern as useFrameV2, so the home never changes look half-way through a render tree.
import { useState } from 'react';
import { isEncounterFlagOn } from './encounter-flags';

export function useReadyList(): boolean {
  const [on] = useState(() => isEncounterFlagOn('readyList'));
  return on;
}
